import { Injectable } from '@angular/core';
import { UserSession } from './shared/user-session';
import { UtilService } from './shared/util.service';
import { HolisticMemberProfileService } from './shared/holistic-member-profile.service';

const DATA_LOADED_EVENT_NAME = 'ON_DATA_LOADED';

@Injectable()
export class AppStartupService {
  // OOo = (<any>window).OOo;
  /************************************************************ */
  // KEEPING THE OOo CODE COMMENTED FOR FUTURE REFERENCE FOR FEEDBACK LINK
  /************************************************************ */
  constructor(
    private userSession: UserSession,
    private utilService: UtilService,
    private holisticMemberProfileService: HolisticMemberProfileService) { }

  init(): void {
    // intializing OOo Feedback module.
    // this.initializeFeedbackModule();
  }

  // private initializeFeedbackModule() {
  //   const deviceType = this.utilService.getDeviceType();
  //   const nativeOS = this.utilService.getNativeOS();

  //   if (deviceType !== 'mobile' &&  this.utilService.getDeviceType2() !== 'tablet' && this.OOo && typeof this.OOo.createTab === 'function') {
  //      if (this.userSession.getMemberFeatureFlags().showOLInlineIcon) {
  //        this.OOo.createTab();
  //      }
  //      if (this.userSession.getMemberFeatureFlags().showOLFloatingIcon === true) {
  //        this.OOo.createFloatingButton();
  //      }
  //  }

  //   const isBlueRewardsAlertVisible = this.userSession.getMemberFeatureFlags().showBlueRewardsAlert
  //     && this.userSession.getMemberAttributes().incnActExpectedCompDateApplicable;

  //   if (this.userSession.getMemberFeatureFlags().showOLInviteFeedback
  //     && nativeOS !== 'Android' && nativeOS !== 'iOS') {
  //     if (
  //       (isBlueRewardsAlertVisible
  //         && (this.userSession.getMemberAttributes().healthyBlueProduct
  //           || (this.holisticMemberProfileService.isBlueRewardMember()
  //             && !this.userSession.getMemberAttributes().houseAccount
  //             && this.userSession.getMemberAttributes().incnRewardType !== 'No Incentive Payment'
  //           )
  //           || ((this.holisticMemberProfileService.isBlueRewardMember() || this.holisticMemberProfileService.isWellnessMember())
  //             && this.userSession.getMemberAttributes().houseAccount
  //           )
  //           || (this.holisticMemberProfileService.isWellnessSOMMember()
  //             && this.userSession.getMemberFeatureFlags().showBlueRewards)
  //         )
  //       )
  //       || (this.userSession.getMemberCoverageFlags().voidedForNoBinderPayment
  //           || this.userSession.getMemberFeatureFlags().showPMBDelinquencyMessage
  //       ) && (this.userSession.getMemberFeatureFlags().needGlobalConsent && !this.userSession.getMemberProfile().impersonation)
  //     ) {
  //       this.userSession.setCookie('LaunchOLInvite', 'N');
  //     } else {
  //       this.userSession.setCookie('LaunchOLInvite', 'Y');
  //     }
  //   } else {
  //     this.userSession.setCookie('LaunchOLInvite', 'N');
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/app/app-startup.service.ts